<template>
  <div class="box box-success">

    <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub"><img src="/static/img/icons/almacen-verde.png"> Reglas</h3>
      <i class="fa fa-caret-right"> </i>
      <h3 :to="{ name: 'InventoryDetail', params: {accountCode: this.selectedAccount.code} }" class="box-title box-title-sub" style="padding-left:5px"> {{this.selectedAccount.name}}</h3>
      <i class="fa fa-caret-right"> </i> 
      <h3 class="box-title box-title-sub" style="padding-left:5px" > Registro</h3>
    </div>

    <form @submit.prevent="handleSubmit" autocomplete="off">
      <div class="box-body">
        <div class="filterContainer">
        <div class="row">
          <div class="col-md-4">      
            <div id="divAccountSelect" class="form-group">
              <label>Cuenta</label>  
              <multiselect
                :value="this.selectedAccount"
                selectLabel="Presione enter para seleccionar"
                selectedLabel="Seleccionado"
                deselectLabel="Seleccionado"
                track-by="name"
                :placeholder="this.selectedAccount.name"
                :allow-empty="false"
                label="name"
                :options="this.optionsAccount"
                @input="onAccountSelect">
                <span slot="noResult">
                  No se encontraron resultados
                </span>
              </multiselect>
            </div>
          </div>
        </div>
        <div class="row" style="padding-top:25px;">
          <div class="col-md-3">      
            <div class="form-group">  
              <label for="ddlType">Tipo de Conteo</label>  
              <select id="ddlType" v-model="selectedEriType" class="form-control">
                <option v-for="type in this.optionsEriType" v-bind:key="type.code" v-bind:value="type.code">
                  {{ type.name }}
                </option>
              </select>
              <div v-show="submitted && !selectedEriType" class="invalid-feedback">Tipo Requerido</div>
            </div>
          </div>
          <div class="col-md-3">      
            <div class="form-group">  
              <label for="dtDate">Fecha</label>
              <input id="dtDate" type="text" name="dtpFecha" class="form-control" disabled/>
              <div v-show="submitted && !selectedDate" class="invalid-feedback">Fecha Requerida</div>
              <div v-show="submitted && selectedDate !== todayDate" class="invalid-feedback">Fecha Incorrecta</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">      
            <div class="form-group">  
              <label for="numSkuSquare">SKU Cantidad Cuadrada</label>
              <input id="numSkuSquare" v-model="squaredSkuCount" type="number" min="0" class="form-control"/>
              <div v-show="submitted && squaredSkuCount <= 0" class="invalid-feedback">Cant. Cuadrada Requerida</div>
            </div>
          </div>
          <div class="col-md-3">      
            <div class="form-group">  
              <label for="numSkuInventory">SKU Cantidad Inventariada</label>
              <input id="numSkuInventory" v-model="inventoriedSkuCount" type="number" min="0" class="form-control"/>
              <div v-show="submitted && inventoriedSkuCount <= 0" class="invalid-feedback">Cant. Inventariada Requerida</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <input v-bind:class="['btn btn-success', { 'disabled' : (submitted && !selectedAccount && !selectedEriType && !selectedDate && !squaredSkuCount && !inventoriedSkuCount) }]" type="submit" value="Registrar">
          </div>
        </div>
      </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import 'bootstrap-daterangepicker/daterangepicker.css'
import 'bootstrap-daterangepicker/daterangepicker.js'
import moment from 'moment/moment.js'
import constants from 'assets/js/constants.js'
import Modal from 'components/modal/Modal.vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'InventoryEntry',
  data () {
    return {
      loader: null,
      submitted: false,
      optionsAccount: [],
      selectedAccount: null,
      optionsEriType: null,
      todayDate: '',
      selectedEriType: '',
      selectedDate: '',
      squaredSkuCount: '',
      inventoriedSkuCount: ''
    }
  },
  created () {
    this.loadSelectData()
    this.todayDate = moment().format('MM/DD/YYYY')
    this.selectedDate = this.todayDate
  },
  mounted () {
    $(this.$el).find('#dtDate').daterangepicker(
      {
        singleDatePicker: true,
        showDropdowns: true,
        minYear: 2010,
        maxYear: moment().year(),
        locale: constants.datePickerLocale
      }
    )

    $(this.$el).find('#numSkuSquare, #numSkuInventory').keydown(function (e) {
      // Allow: backspace, delete, tab, escape, enter and .
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
          // Allow: Ctrl/cmd+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl/cmd+C
        (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl/cmd+X
        (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
              // let it happen, don't do anything
        return
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault()
      }
    })
  },
  components: {
    Modal,
    Multiselect
  },
  computed: {
    ...mapGetters([
      'userClients'
    ])
  },
  methods: {
    ...mapActions([
      'inventoryEntry'
    ]),
    loadSelectData () {
      // Client
      let preselectedAccount = this.userClients.filter(item => item.code === this.$route.params.accountCode)

      if (preselectedAccount.length > 0) {
        this.optionsAccount = preselectedAccount
        this.selectedAccount = preselectedAccount[0]
      } else {
        this.optionsAccount = this.userClients
        this.selectedAccount = this.userClients[0]
      }

      // Eri
      this.optionsEriType = constants.defaultEriTypes
      this.selectedEriType = this.optionsEriType[0].code
    },
    onAccountSelect (account) {
      this.selectedAccount = account
    },
    handleSubmit () {
      document.activeElement.blur()

      this.submitted = true
      this.selectedDate = $(this.$el).find('#dtDate').data('daterangepicker').startDate.format('MM/DD/YYYY')

      if (this.selectedEriType && this.selectedAccount && this.selectedDate === this.todayDate && this.inventoriedSkuCount > 0 && this.squaredSkuCount > 0) {
        let loader = this.$loading.show({
          loader: 'dots'
        })

        let params = {
          EriType: this.selectedEriType,
          AccountCode: this.selectedAccount.code,
          Date: this.selectedDate + ' ' + moment().format('HH:mm:ss'),
          InventoriedSkuCount: this.inventoriedSkuCount,
          SquaredSkuCount: this.squaredSkuCount
        }

        this.inventoryEntry(params)
        .then((response) => {
          this.submitted = false

          let title, description

          if (response) {
            title = 'Éxito'
            description = 'Se registró ERI exitosamente.'
            this.inventoriedSkuCount = ''
            this.squaredSkuCount = ''
          } else {
            title = 'Error'
            description = 'Ocurrió un error al momento de registrar ERI.'
          }

          this.$bus.$emit('modal-open', {
            title: title,
            description: description,
            type: 'info',
            confirmText: 'Aceptar',
            cancelText: null,
            confirmBefore: () => {
            },
            confirmAfter: () => {
            },
            cancelBefore: () => {
            },
            cancelAfter: () => {
            }
          })

          loader.hide()
        })
      }
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// InventoryEntry.vue?086ca866